var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-popover",
    { attrs: { "auto-hide": true } },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-xs btn-default",
          on: {
            click: function ($event) {
              return _vm.getData()
            },
          },
        },
        [_c("i", { staticClass: "icon-fa icon-fa-exchange" })]
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "popover" },
        [
          _vm.loading
            ? [_vm._v("\n      loading...\n    ")]
            : _vm._l(_vm.statData, function (r) {
                return _c("div", { staticClass: "card mb-1" }, [
                  _c(
                    "div",
                    { staticClass: "card-body p-1" },
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.printDate(
                              r.supplier_record.created_at,
                              "DD.MM.YYYY"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      +r.supplier_record.data?.error === 404
                        ? [_c("p", [_vm._v("Препарат не найден на сайте")])]
                        : [
                            +(r.supplier_record.data?.in_stores ?? 0) === 0
                              ? [_c("p", [_vm._v("нет в аптеках")])]
                              : _vm._e(),
                            _vm._v(" "),
                            [
                              _c("p", [
                                _vm._v("ц: "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      r.supplier_record.data?.min_price ?? 0
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                r.supplier_record.data?.average_price
                                  ? _c("span", [
                                      _vm._v("Ø "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            r.supplier_record.data
                                              .average_price ?? 0
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v("a: "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        r.supplier_record.data.in_stores ?? 0
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v("(с/в: "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        r.supplier_record.data?.pickup_shop ?? 0
                                      ) +
                                        "/" +
                                        _vm._s(
                                          r.supplier_record.data
                                            ?.pickup_shop_later ?? 0
                                        )
                                    ),
                                  ]),
                                  _vm._v(")"),
                                ]),
                              ]),
                            ],
                          ],
                    ],
                    2
                  ),
                ])
              }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }